import FirebaseEnvs from "./FirebaseEnvs"

const firebaseConfig = { ...FirebaseEnvs.prod }

export default firebaseConfig
